
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/input-number.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-weet-input-number-demo-basic","docs-weet-input-number-demo-step","docs-weet-input-number-demo-format","docs-weet-input-number-demo-prefix-suffix"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/input-number.md?type=demo')
};